import React from 'react';
export function Footer() {
  return <footer className="bg-navy-900 text-cream-50/60 py-8 md:py-12 px-4 md:px-6 text-center text-xs md:text-sm border-t border-navy-800" data-id="element-119">
      <div className="max-w-4xl mx-auto" data-id="element-120">
        <p className="mb-3 md:mb-4 font-medium text-cream-50/80" data-id="element-121">
          ✝ MegaKit de Catequesis Infantil — lulu.digitalshop@gmail.com ·
          @lulu.digitalshop
        </p>
        <p data-id="element-122">© 2026 — Todos los derechos reservados.</p>
      </div>
    </footer>;
}